import $ from "jquery";
import fb from "@bd-core/firebase";
import bdjs from "@bd-core/bdjs";
import Timer from "@bd-utils/timer";
import RoundTimer from "@bd-utils/round-timer";
import {
    setFinished,
    setRoundStartedAt,
    setRoundShouldEndAt,
    setCurrentRound,
    getCurrentRound,
    setRoundStatus,
    setScore,
    getScore,
    setFossilEnergy,
    setGreenEnergy,
    getGreenEnergy,
    getFossilEnergy,
    getRoundStatus,
    setFossilPerRound,
    setGreenPerRound,
    getFossilPerRound,
    getGreenPerRound,
} from "@bd-stores/game-progress";
import { store } from "@bd-stores/store";
import CONFIG from "./config";
import {
    setRoundChanges,
    updateRoundEnergyUsage,
    updateRoundStatus,
    updateTeamScore,
} from "./firebase-actions";
import bdapi from "@bd-core/bd-api";
// import NumberAnimator from "@bd-utils/number-animator";
import NumberAnimator2 from "@bd-utils/number-animator-2";
import compile from "@bd-utils/handlerbars-helper";
import CycleTrack from "@bd-utils/cycle-track";

const GameLogic = {
    transitionDuration: 1000,

    async init() {
        if ($(".app").length < 1) return false;

        this.timer = new Timer(this.onTimeOut.bind(this));
        this.roundTimer = new RoundTimer();
        // this.numberAnimator = new NumberAnimator();
        this.numberAnimator2 = new NumberAnimator2();
        this.cycleTrack = new CycleTrack();

        // Initialize Firebase
        //-----------------------------------------------------------------------
        try {
            await fb.initializeGame();
        } catch (e) {
            console.error(e);
        }

        this.registerGlobalEvents();
        this.registerGlobalListener();

        this.timer.init(); // session timer

        this.cycleTrack.init();

        // Initialize round timer AFTER Firebase is ready
        this.roundTimer.init(); // round countdown timer

        // Initialize number animator
        // this.numberAnimator.init();
        this.numberAnimator2.init();
        //-----------------------------------------------------------------------
    },

    registerGlobalListener() {
        const onTeamAttributesChanged = (e, eventData) => {
            const currentRound = eventData?.data?.currentRoundId;
            const roundStartedAt = eventData?.data?.roundStartedAt;
            const roundShouldEndAt = eventData?.data?.roundShouldEndAt;
            const score = eventData?.data?.score || 0;

            store.dispatch(setCurrentRound(currentRound));
            store.dispatch(setRoundStartedAt(roundStartedAt));
            store.dispatch(setRoundShouldEndAt(roundShouldEndAt));

            if (score) {
                store.dispatch(setScore(score));
            }

            const isFinished = eventData?.data?.isFinished || false;
            if (!isFinished) return;

            store.dispatch(setFinished(true));
            this.timer.stopTimer();

            bdjs.showLoading();

            setTimeout(() => {
                $(".app").html("");

                setTimeout(() => this.onFinish(), this.transitionDuration);
            }, this.transitionDuration);
        };

        const onRoundStatusChanged = (roundId, roundStatus) => {
            if (!roundStatus) return;

            const currentRound = getCurrentRound();

            if (roundId === currentRound && roundStatus === "finished") {
                this.handleUsedEnergyBar();
                this.handleScoreChanges();
                this.setGreenEnergyTotal();
                this.setFossilEnergyBar();
                this.handleTaskOnRoundFinished(roundId, "onFinish");
            }

            if (roundId === currentRound && roundStatus === "started") {
                this.handleCurrentRound(roundId);
                this.handleTaskChanges(roundId);
            }
        };

        const onRoundDataChanged = (e, eventData) => {
            const roundsData = eventData?.data || false;

            /**
             * @type {BD_StoreGameProgress['roundStatus']}
             */
            let tmpRoundStatus = {};

            if (roundsData) {
                $.each(roundsData, (roundId, roundData) => {
                    // @ts-ignore
                    roundId = isNaN(roundId) ? roundId : parseInt(roundId);

                    const roundStatus = roundData?.status;

                    if (roundStatus) {
                        onRoundStatusChanged(roundId, roundStatus);
                        tmpRoundStatus[roundId] = roundStatus;
                    }
                });
            }

            store.dispatch(setRoundStatus(tmpRoundStatus));

            this.maybeAllRoundsFinished();
        };

        const onTeamEnergyChanged = (e, eventData) => {
            const roundEnergys = eventData?.data || false;

            if (!roundEnergys) return;

            /**
             * @type {BD_StoreGameProgress['fossilPerRound']}
             */
            let tmpFossilPerRound = {};

            /**
             * @type {BD_StoreGameProgress['greenPerRound']}
             */
            let tmpGreenPerRound = {};

            const currentRound = getCurrentRound();
            let totalGreenEnergy = 0;
            let totalFossilEnergy = 0;

            $.each(roundEnergys, (roundId, roundEnergy) => {
                // @ts-ignore
                roundId = parseInt(roundId);

                tmpFossilPerRound[roundId] =
                    roundEnergy?.fossil?.energyUsage || 0;
                tmpGreenPerRound[roundId] =
                    roundEnergy?.green?.energyUsage || 0;

                totalGreenEnergy += roundEnergy?.green?.energyUsage || 0;
                totalFossilEnergy += roundEnergy?.fossil?.energyUsage || 0;

                store.dispatch(setGreenEnergy(totalGreenEnergy));
                store.dispatch(setFossilEnergy(totalFossilEnergy));

                if (roundId === currentRound) {
                    const greenEnergy = roundEnergy?.green || false;
                    const fossilEnergy = roundEnergy?.fossil || false;
                    const $usedBar = $(".js-energy-used-bar");

                    if (!$usedBar.length) return;

                    if (greenEnergy) {
                        const greenEnergyAmount = greenEnergy?.energyUsage || 0;
                        const template = $("#used-bar").html();

                        const $energyBar = $(
                            `.js-day-cycle[data-id="${roundId}"] .js-energy-bar`,
                        );

                        let barTypes = [];

                        if (greenEnergyAmount > 0) {
                            $energyBar.removeClass("is-completed");
                            $usedBar.html("");

                            for (let i = 0; i < greenEnergyAmount; i++) {
                                const $userBarPerRound = $energyBar.eq(i);
                                const energyType =
                                    $userBarPerRound.data("energy-type");

                                $userBarPerRound.addClass("is-completed");

                                if (energyType) {
                                    barTypes.push(energyType);
                                }
                            }

                            if (barTypes.length) {
                                $usedBar.html("");
                                barTypes.forEach((barType) => {
                                    const html = compile(template, {
                                        energyType: barType,
                                    });
                                    $usedBar.append(html);
                                });
                            }
                        } else {
                            $energyBar.removeClass("is-completed");
                            $usedBar.html("");
                        }
                    }

                    if (fossilEnergy) {
                        const fossilEnergyAmount =
                            fossilEnergy?.energyUsage || 0;
                        const template = $("#used-bar").html();

                        if (fossilEnergyAmount > 0) {
                            for (let i = 0; i < fossilEnergyAmount; i++) {
                                const html = compile(template, {
                                    energyType: "is-usedUp",
                                });

                                if ($usedBar.length) {
                                    $usedBar.append(html);
                                }
                            }
                        } else {
                            const $fossilBar = $(
                                ".js-energy-used-bar.is-usedUp",
                            );

                            setTimeout(() => {
                                if ($fossilBar.length) {
                                    $fossilBar.remove();
                                }
                            }, 950);
                        }
                    }
                }
            });

            store.dispatch(setFossilPerRound(tmpFossilPerRound));
            store.dispatch(setGreenPerRound(tmpGreenPerRound));
        };

        const onPlayersStateChanged = (e, eventData) => {
            const players = eventData?.data;
            // const onlinePlayers = players.filter((player) => player.isOnline);
            const playerAmount = players.length - 1; // exclude the leader or facilitator
            const $playerAmount = $(".js-player-amount");

            $playerAmount.text(playerAmount);
        };

        bdjs.listen("bd__playersStateChanged", onPlayersStateChanged);
        bdjs.listen("bd__roundDataChanged", onRoundDataChanged);
        bdjs.listen("bd__teamEnergyChanged", onTeamEnergyChanged);
        bdjs.listen("bd__teamAttributeChanged", onTeamAttributesChanged);

        this.listenGameProgressChanged();
    },

    registerGlobalEvents() {
        const $appPage = $(".app__page");

        $appPage.on("click", ".js-task-item", this.handleClickedTaskItem);
    },

    listenGameProgressChanged() {},

    handleScoreChanges() {
        const score = getScore();
        this.numberAnimator2.animate(score);
    },

    handleGameOverPopup(isFossilEnergyUsedUp = false) {
        const gameOverPopup = CONFIG.game.gameOverPopup;

        const $popup = $(".js-game-over-popup");

        if (isFossilEnergyUsedUp) {
            $popup.find(".js-title-popup").text(gameOverPopup.fossil_title);
            $popup
                .find(".js-content-popup")
                .text(gameOverPopup.fossil_description);
            $popup
                .find(".js-icon-popup")
                .attr("src", gameOverPopup.fossil_icon);
            $popup.addClass("is-fossil");
        } else {
            $popup
                .find(".js-title-popup")
                .text(gameOverPopup.round_finish_title);
            $popup
                .find(".js-content-popup")
                .text(gameOverPopup.round_finish_description);
            $popup
                .find(".js-icon-popup")
                .attr("src", gameOverPopup.round_finish_icon);
        }

        $popup.addClass("is-open");
    },

    async onFinish(isFossilEnergyUsedUp = false) {
        const totalScore = getScore();
        const totalGreenEnergy = getGreenEnergy();
        const totalFossilEnergy = getFossilEnergy();

        await bdjs.goAsync(
            bdapi.post("game/finish-game", {
                total_points: totalScore,
                is_fossil_energy_used_up: isFossilEnergyUsedUp ? 1 : 0,
                total_green_energy: totalGreenEnergy,
                total_fossil_energy: totalFossilEnergy,
            }),
        );

        const currentPage = window.location.pathname;

        bdjs.showLoading();

        setTimeout(() => {
            if (currentPage === "/phone") {
                window.location.href = CONFIG.siteURL + "/end-page/";
            } else {
                window.location.href = CONFIG.siteURL + "/result/";
            }
        }, this.transitionDuration);
    },

    async onTimeOut() {
        const totalScore = getScore();
        const totalGreenEnergy = getGreenEnergy();
        const totalFossilEnergy = getFossilEnergy();

        await bdjs.goAsync(
            bdapi.post("game/timeout", {
                total_points: totalScore,
                total_green_energy: totalGreenEnergy,
                total_fossil_energy: totalFossilEnergy,
            }),
        );

        const currentPage = window.location.pathname;

        bdjs.showLoading();

        setTimeout(() => {
            if (currentPage === "/phone") {
                window.location.href = CONFIG.siteURL + "/end-page/";
            } else {
                window.location.href = CONFIG.siteURL + "/result/";
            }
        }, this.transitionDuration);
    },

    beforeFinishGame(isFossilEnergyUsedUp = false) {
        this.timer.stopTimer();
        this.roundTimer.stopTimer();
        this.handleGameOverPopup(isFossilEnergyUsedUp);

        setTimeout(() => {
            this.onFinish(isFossilEnergyUsedUp);
        }, 3000);
    },

    setFossilEnergyBar() {
        const totalFossilEnergy = getFossilEnergy();
        const initialFossilEnergy = CONFIG.game.fossilEnergy.initial;
        const $fossilEnergyBar = $(".js-fossilEnergy-bar");
        const currentFossilEnergy = initialFossilEnergy - totalFossilEnergy;
        const energyPercentage = Math.round(
            (currentFossilEnergy / initialFossilEnergy) * 100,
        );
        const barlengthClas = `loading-${energyPercentage}`;

        // remove the old loading classes
        $fossilEnergyBar.removeClass(function (index, className) {
            return (className.match(/(^|\s)loading-\S+/g) || []).join(" ");
        });

        // add the new loading class
        $fossilEnergyBar.addClass(barlengthClas);

        if (currentFossilEnergy <= 0) {
            this.beforeFinishGame(true);
        }
    },

    setGreenEnergyTotal() {
        const totalGreenEnergy = getGreenEnergy();
        const totalFossilEnergy = getFossilEnergy();
        const totalEnergy = totalGreenEnergy + totalFossilEnergy;
        let greenEnergyPercentage = Math.round(
            (totalGreenEnergy / totalEnergy) * 100,
        );
        greenEnergyPercentage = isNaN(greenEnergyPercentage)
            ? 0
            : greenEnergyPercentage;

        const greenEnergyTotal = $(".js-greenEnergy-percentage");
        greenEnergyTotal.text(greenEnergyPercentage);
    },

    async handleRoundChanges(roundID, timer) {
        await setRoundChanges(roundID, timer);
    },

    handleUpdateRoundStatus(roundID, roundStatus) {
        if (!roundID) return;
        if (!roundStatus) return;

        updateRoundStatus(roundID, roundStatus);
    },

    handleCurrentRound(roundID) {
        const $currentRound = $(".js-day-cycle.is-primary");
        const currentRoundID = $currentRound.data("id");

        if (currentRoundID === roundID) return;

        const $round = $(`.js-day-cycle[data-id="${roundID}"]`);

        if ($round.length) {
            $(".js-cycle-carousel").attr("data-item", $round.index());
            this.cycleTrack.currentIndex = $round.index();
            this.cycleTrack.initializeSlider();
        }
    },

    handleUsedEnergyBar() {
        const $usedBar = $(".js-energy-used-bar");
        $usedBar.html("");
    },

    handleTaskOnRoundFinished(roundId, type) {
        const currentPage = window.location.pathname;
        if (currentPage !== "/phone") return;

        const self = this;
        const rounds = CONFIG.game.rounds;
        const $existingTasks = $(".js-task-item");

        if (!$existingTasks.length) return;

        const currentRoundIndex =
        // @ts-ignore
            rounds.findIndex((round) => round.id === roundId) + 1;

        $existingTasks.each(function () {
            const $this = $(this);
            const taskId = $this.data("id");
            const $deadline = $this.find(".js-deadline");
            const startedAt = Number($deadline.data("started-at"));
            // @ts-ignore
            const startedAtIndex =
                // @ts-ignore
                rounds.findIndex((round) => round.id === startedAt) + 1;
            const deadline = Number($deadline.data("deadline"));

            const roundDeadlineIndex = startedAtIndex + deadline;
            const remainingRounds = Math.max(
                0,
                roundDeadlineIndex - currentRoundIndex,
            );

            if (remainingRounds <= 0) {
                // Task has expired - mark as expired and remove from display
                if (!$this.hasClass("is-completed")) {
                    self.handleTaskExpired(taskId, roundId);
                }
            } else {
                // Calculate progress percentage (remaining deadline / original deadline)
                // Progress starts at 100% and decreases to 0% as deadline approaches
                const progressPercentage = remainingRounds;

                // Remove old loading classes
                $deadline.removeClass(function (index, className) {
                    return (className.match(/(^|\s)loading-\S+/g) || []).join(
                        " ",
                    );
                });

                // Add new loading class based on progress
                $deadline.addClass(`loading-${progressPercentage}`);

                // Add warning class if progress is low (less than 20%)
                if (progressPercentage <= 1 && progressPercentage > 0) {
                    $this.addClass("is-warning");
                } else {
                    $this.removeClass("is-warning");
                }
            }

            if ($this.hasClass("is-completed") && type === "onFinish") {
                $this.addClass("is-removed");
                setTimeout(() => {
                    $this.remove();
                }, 2000);
            }
        });
    },

    async handleTaskChanges(roundId) {
        const currentPage = window.location.pathname;
        if (currentPage !== "/phone") return;

        const $taskList = $(".js-task-list");
        const $existingTasks = $(".js-task-item");

        const templatedTaskList = $("#task-list").html();
        let newTasks = [];

        const [res] = await bdjs.goAsync(
            bdapi.post("game/get-tasks", {
                round_id: roundId,
            }),
        );

        if (res?.data?.data?.tasks) {
            newTasks = res.data.data.tasks;
        }

        // Get existing task IDs to avoid duplicates
        const existingTaskIds = $existingTasks
            .map(function () {
                return $(this).data("id");
            })
            .get();

        // Filter out tasks that already exist
        let uniqueNewTasks = newTasks.filter(
            (task) => !existingTaskIds.includes(task.id),
        );

        if (uniqueNewTasks.length > 0) {
            const html = compile(templatedTaskList, { tasks: uniqueNewTasks });
            $taskList.append(html);
            this.handleTaskOnRoundFinished(roundId);
        }
    },

    async handleTaskExpired(taskId, roundId) {
        const currentPage = window.location.pathname;
        if (currentPage !== "/phone") return;

        if (!taskId) return;

        await bdjs.goAsync(
            bdapi.post("game/expired-task", {
                task_id: taskId,
                round_id: roundId,
            }),
        );

        const scoreParameters = CONFIG.game.scoreParameters;
        const score = Number(scoreParameters.task_expired);
        updateTeamScore(score);

        const $this = $(`.js-task-item[data-id="${taskId}"]`);

        $this.removeClass("is-warning");
        $this.addClass("is-expired");

        $this.addClass("is-removed");
        setTimeout(() => {
            $this.remove();
        }, 2000);
    },

    async handleClickedTaskItem() {
        const currentPage = window.location.pathname;
        if (currentPage !== "/phone") return;

        const $this = $(this);
        const taskId = $this.data("id");
        const currentRound = getCurrentRound();
        const isCompleted = $this.hasClass("is-completed");

        let energyCost = $this.find(".js-level").data("level");
        energyCost = energyCost.toLowerCase();

        if (energyCost === "low") {
            energyCost = 1;
        } else if (energyCost === "medium") {
            energyCost = 2;
        } else if (energyCost === "high") {
            energyCost = 3;
        }

        const scoreParameters = CONFIG.game.scoreParameters;
        const taskScore = Number(scoreParameters.task_finished);
        const energyUsageScore = Number(scoreParameters.energy_usage);
        const fossilScore = Number(scoreParameters.fossil_energy_usage);
        const greenScore = Number(scoreParameters.green_energy_usage);
        let energyCostScore = energyCost * energyUsageScore;
        let totalScore = taskScore + energyCostScore;

        if (isCompleted) {
            $this.removeClass("is-completed");

            const [res] = await bdjs.goAsync(
                bdapi.post("game/undo-finish-task", {
                    task_id: taskId,
                    round_id: currentRound,
                }),
            );

            if (res?.data?.data?.energy_usage) {
                const energyUsage = res.data.data.energy_usage;
                const fossilEnergy = energyUsage.find(
                    (energy) => energy?.energyType === "fossil",
                );
                const greenEnergy = energyUsage.find(
                    (energy) => energy?.energyType === "green",
                );

                if (fossilEnergy) {
                    const fossilEnergyAmount = fossilEnergy.energyAmount;
                    const totalFossilPerRound = getFossilPerRound(currentRound);
                    const deductedFossilAmount = 
                        fossilEnergyAmount <= 0 ? totalFossilPerRound :
                        totalFossilPerRound - fossilEnergy.energyAmount;
                    const deductedFossilScore = deductedFossilAmount * fossilScore;

                    totalScore += deductedFossilScore;

                }

                if (greenEnergy) {
                    const greenEnergyAmount = greenEnergy.energyAmount;
                    const totalGreenPerRound = getGreenPerRound(currentRound);
                    const deductedGreenAmount = 
                        greenEnergyAmount <= 0 ? totalGreenPerRound :
                        totalGreenPerRound - greenEnergy.energyAmount;
                    const deductedGreenScore = deductedGreenAmount * greenScore;

                    totalScore += deductedGreenScore;

                }

                updateTeamScore(-totalScore);
                updateRoundEnergyUsage(currentRound, energyUsage);
            }
        } else {
            $this.addClass("is-completed");

            const [res] = await bdjs.goAsync(
                bdapi.post("game/finish-task", {
                    task_id: taskId,
                    round_id: currentRound,
                }),
            );

            if (res?.data?.data?.energy_usage) {
                const energyUsage = res.data.data.energy_usage;
                const fossilEnergy = energyUsage.find(
                    (energy) => energy?.energyType === "fossil",
                );
                const greenEnergy = energyUsage.find(
                    (energy) => energy?.energyType === "green",
                );

                if (fossilEnergy.energyAmount > 0) {
                    const fossilEnergyScore =
                        fossilEnergy.energyAmount * fossilScore;

                    totalScore += fossilEnergyScore;
                }
                if (greenEnergy.energyAmount > 0) {
                    const greenEnergyScore =
                        greenEnergy.energyAmount * greenScore;

                    totalScore += greenEnergyScore;
                }

                updateTeamScore(totalScore);
                updateRoundEnergyUsage(currentRound, energyUsage);
            }
        }
    },

    maybeAllRoundsFinished() {
        const rounds = CONFIG.game.rounds;
        let isAllRoundsFinished = true;

        $.each(rounds, (index, round) => {
            // @ts-ignore
            const roundId = round.id;
            const roundStatus = getRoundStatus(roundId);

            if (roundStatus !== "finished") {
                isAllRoundsFinished = false;
                return false;
            }
        });

        if (isAllRoundsFinished) {
            this.beforeFinishGame();
        }
    },
};

export default GameLogic;
